import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Field, reduxForm } from 'redux-form';
import { List } from './../../components/client/';
import { getUserRoles } from '../../utils/helpers';
import { postLoginError } from './../../actions/auth/login';
import { literals } from './../../languages';

class DashboardScreen extends Component {

  constructor (props) {
    super(props);
    this.state = {
      'isAdmin': false
    }
  }

  componentWillMount () {
    let token = localStorage.getItem('betwidgets_login_token');
    if (token) {
      let roles = getUserRoles(token);
      this.setState({
        'isAdmin': roles.indexOf('ROLE_ADMIN') !== -1  ? true : false
      });
    }
    else{
      this.props.postLoginError('Token expired. Please log in again');
      this.props.history.push('/login');
    }
  }

  renderAdminMenu = () => {
    return (
      <nav className="admin-nav">
        <button className="btn btn-secondary" onClick={()=>{this.props.history.push('/languages/')}}>Languages</button>
        <button className="btn btn-secondary" onClick={()=>{this.props.history.push('/products/')}}>Products</button>
        <button className="btn btn-secondary" onClick={()=>{this.props.history.push('/product_options/')}}>Product Options</button>
      </nav>
    );
  }

  handleLogout = () => {
    localStorage.removeItem('betwidgets_login_token');
    this.props.history.push('/login');
  }

  render () {
    return (
      <div className="dashboard-screen">
        <div className="container">
          <button onClick = {this.handleLogout} className="float-right btn btn-danger">{literals.logout[this.props.locale]}</button>
          <h2>{literals.clientsList[this.props.locale]}</h2>
          {this.state.isAdmin ? this.renderAdminMenu() : '' }
          <List locale={this.props.locale} history={this.props.history} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postLoginError: error => dispatch(postLoginError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);



// WEBPACK FOOTER //
// ./src/screens/DashboardScreen/index.js